import { TopListTableNames } from '@/models/top-list/top-list-table-names.model';
import { TopListTableType } from '@/models/top-list/top-list-table-type.model';
import { TopPlayerListSortOrder } from '@/models/top-list/top-player-list-sort-orders.model';

export const TOP_LIST_TABLES_MAP = {
  [TopListTableNames.TOP_WINS]: {
    type: TopListTableType.WINS,
  },
  [TopListTableNames.TOP_WINNERS]: {
    type: TopListTableType.PLAYERS,
    sort: TopPlayerListSortOrder.LOSER_INDEX_ASC,
  },
  [TopListTableNames.TOP_LOSERS]: {
    type: TopListTableType.PLAYERS,
    sort: TopPlayerListSortOrder.LOSER_INDEX_DESC,
  },
};
